import { Container, Typography } from '@mui/material'

const AccessDenied = (): JSX.Element => {
  return (
    <Container
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#F5F7FA',
      }}
      maxWidth={false}
    >
      <Typography>401</Typography>
    </Container>
  )
}
export default AccessDenied
